(function () {
  if (window.__alenkaConstructorBooted) return;
  window.__alenkaConstructorBooted = true;

  const state = window.__alenkaConstructorState || (window.__alenkaConstructorState = {});

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function money(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const amount = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);

    const symbols = {
      EUR: '€',
      USD: '$',
      GBP: '£',
      CHF: 'CHF',
      CAD: 'CA$',
      AUD: 'A$',
      JPY: '¥'
    };

    const symbol = symbols[currency] || currency;
    return `${symbol} ${amount}`;
  }

  function uniqueBy(arr, keyFn) {
    const seen = new Set();
    return arr.filter((item) => {
      const key = keyFn(item);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function initPanel(panel) {
    const dataNode = panel.querySelector('[data-ac-data]');
    if (!dataNode) return;

    const data = JSON.parse(dataNode.textContent);
    const role = data.role;
    const products = Array.isArray(data.products) ? data.products : [];
    const placeholderImage = data.placeholderImage || '';

    const colorsWrap = panel.querySelector('[data-ac-colors]');
    const productsWrap = panel.querySelector('[data-ac-products]');
    const imageEl = panel.querySelector('[data-ac-image]');
    const viewerLink = panel.querySelector('[data-ac-viewer-link]');
    const titleEl = panel.querySelector('[data-ac-title]');
    const priceEl = panel.querySelector('[data-ac-price]');
    const selectedColorEl = panel.querySelector('[data-ac-selected-color]');
    const sizesWrap = panel.querySelector('[data-ac-sizes]');
    const emptyEl = panel.querySelector('[data-ac-empty]');
    const prevBtn = panel.querySelector('[data-ac-prev]');
    const nextBtn = panel.querySelector('[data-ac-next]');
    let suppressViewerClickUntil = 0;

    function moveProduct(direction) {
      if (!s.visibleProducts.length) return;

      const currentIndex = s.visibleProducts.findIndex((product) => String(product.id) === String(s.activeProductId));
      let nextIndex = currentIndex + direction;

      if (nextIndex < 0) nextIndex = s.visibleProducts.length - 1;
      if (nextIndex >= s.visibleProducts.length) nextIndex = 0;

      s.activeProductId = s.visibleProducts[nextIndex].id;
      s.selectedSize = null;
      renderAll();
    }

    if (!state[role]) {
      state[role] = {
        selectedColorHandle: null,
        selectedColorLabel: null,
        activeProductId: null,
        selectedSize: null,
        selectedVariantId: null,
        visibleProducts: []
      };
    }

    const s = state[role];

    if (viewerLink) {
      viewerLink.addEventListener('click', (event) => {
        if (viewerLink.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      });
    }

    function buildColorMap() {
      const map = new Map();

      products.forEach((product) => {
        (product.colors || []).forEach((color) => {
          const handle = normalize(color.handle || color.label);
          if (!handle || map.has(handle)) return;

          map.set(handle, {
            handle: color.handle || color.label,
            label: color.label || color.handle,
            color: color.color
          });
        });
      });

      function parseRgb(value) {
        const match = String(value || '').match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i);
        if (!match) return null;

        return {
          r: Number(match[1]) / 255,
          g: Number(match[2]) / 255,
          b: Number(match[3]) / 255
        };
      }

      function rgbToHsv({ r, g, b }) {
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const delta = max - min;

        let h = 0;

        if (delta !== 0) {
          if (max === r) h = ((g - b) / delta) % 6;
          else if (max === g) h = (b - r) / delta + 2;
          else h = (r - g) / delta + 4;

          h *= 60;
          if (h < 0) h += 360;
        }

        const s = max === 0 ? 0 : delta / max;
        const v = max;

        return { h, s, v };
      }

      function getSortWeight(color) {
        const rgb = parseRgb(color.color);
        if (!rgb) return 1000;

        const { h, s, v } = rgbToHsv(rgb);

        if (s < 0.08 && v > 0.9) return -100;
        if (v < 0.1) return 1000;

        return (h + 60) % 360;
      }

      return Array.from(map.values()).sort((a, b) => getSortWeight(a) - getSortWeight(b));
    }

    function getVisibleProducts() {
      if (!s.selectedColorLabel) return products.slice();

      const selectedLabel = normalize(s.selectedColorLabel);

      return products.filter((product) =>
        (product.variants || []).some((variant) => {
          if (!variant.available) return false;
          return normalize(variant.color) === selectedLabel;
        })
      );
    }

    function getCurrentProduct() {
      const visible = s.visibleProducts.length ? s.visibleProducts : getVisibleProducts();
      if (!visible.length) return null;

      if (!s.activeProductId || !visible.some((product) => String(product.id) === String(s.activeProductId))) {
        s.activeProductId = visible[0].id;
      }

      return visible.find((product) => String(product.id) === String(s.activeProductId)) || visible[0];
    }

    function getMatchingVariants(product) {
      const selectedLabel = normalize(s.selectedColorLabel);

      return (product.variants || []).filter((variant) => {
        if (!variant.available) return false;
        if (selectedLabel && normalize(variant.color) !== selectedLabel) return false;
        return true;
      });
    }

    function getSizeVariants(product) {
      return uniqueBy(getMatchingVariants(product), (variant) => normalize(variant.size));
    }

    function getVariantPreviewImage(product, colorLabel, sizeLabel) {
      const byColor = (product.variants || []).filter((variant) => {
        if (!variant.available) return false;
        if (normalize(variant.color) !== normalize(colorLabel)) return false;
        return true;
      });

      if (!byColor.length) return '';

      if (sizeLabel) {
        const exact = byColor.find((variant) => normalize(variant.size) === normalize(sizeLabel));
        if (exact && exact.previewImage) return exact.previewImage;
      }

      const firstWithImage = byColor.find((variant) => variant.previewImage);
      return firstWithImage?.previewImage || '';
    }

    function resolveSelectedVariant(product) {
      const sizeVariants = getSizeVariants(product);
      if (!sizeVariants.length) {
        s.selectedVariantId = null;
        return null;
      }

      let selectedVariant = null;

      if (s.selectedSize) {
        selectedVariant = sizeVariants.find((variant) => normalize(variant.size) === normalize(s.selectedSize)) || null;
      }

      if (!selectedVariant) {
        selectedVariant = sizeVariants[0];
        s.selectedSize = selectedVariant.size;
      }

      s.selectedVariantId = selectedVariant.id;
      return selectedVariant;
    }

    function renderSwatches() {
      const colorList = buildColorMap();
      const defaultColorKey = normalize(data.defaultColorLabel || 'White');

      if (!s.selectedColorHandle) {
        const defaultColor = colorList.find((color) => normalize(color.handle || color.label) === defaultColorKey);
        const firstColor = colorList[0] || null;
        const initial = defaultColor || firstColor;

        if (initial) {
          s.selectedColorHandle = initial.handle;
          s.selectedColorLabel = initial.label;
        }
      }

      colorsWrap.innerHTML = '';

      if (!colorList.length) {
        colorsWrap.innerHTML = '<div class="ac-empty">No colors available.</div>';
        return;
      }

      colorList.forEach((color) => {
        const handleKey = normalize(color.handle || color.label);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ac-color-btn' + (handleKey === normalize(s.selectedColorHandle) ? ' is-active' : '');
        btn.title = color.label;
        btn.setAttribute('aria-label', color.label);

        const dot = document.createElement('span');
        dot.className = 'ac-color-dot';
        dot.style.backgroundColor = color.color;

        btn.appendChild(dot);

        btn.addEventListener('click', () => {
          s.selectedColorHandle = color.handle || color.label;
          s.selectedColorLabel = color.label || color.handle;
          s.activeProductId = null;
          s.selectedSize = null;
          renderAll();
        });

        colorsWrap.appendChild(btn);
      });
    }

    function renderProducts() {
      s.visibleProducts = getVisibleProducts();
      productsWrap.innerHTML = '';

      if (!s.visibleProducts.length) {
        productsWrap.innerHTML = '<div class="ac-empty" style="white-space: nowrap;">No products for this color.</div>';
        return;
      }

      if (!s.activeProductId || !s.visibleProducts.some((product) => String(product.id) === String(s.activeProductId))) {
        s.activeProductId = s.visibleProducts[0].id;
      }

      s.visibleProducts.forEach((product) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ac-product-btn' + (String(product.id) === String(s.activeProductId) ? ' is-active' : '');
        btn.setAttribute('aria-label', product.title);

        const img = document.createElement('img');
        const preview = getVariantPreviewImage(product, s.selectedColorLabel, null) || placeholderImage || '';
        if (preview) img.src = preview;
        img.alt = product.title;

        btn.appendChild(img);

        btn.addEventListener('click', () => {
          s.activeProductId = product.id;
          s.selectedSize = null;
          renderAll();
        });

        productsWrap.appendChild(btn);
      });
    }

    function renderPrice(variant) {
      if (!variant) return '';

      const price = Number(variant.price || 0);
      const compareAt = Number(variant.compareAtPrice || 0);

      if (compareAt > price) {
        return `
          <div class="ac-price-wrap">
            <span class="ac-price-compare">${money(compareAt)}</span>
            <span class="ac-price-sale">${money(price)}</span>
            <span class="ac-price-badge">In offerta</span>
          </div>
        `;
      }

      return `<div class="ac-price-sale">${money(price)}</div>`;
    }

    function setViewerImage(src, altText) {
      if (src) {
        imageEl.src = src;
      } else {
        imageEl.removeAttribute('src');
      }
      imageEl.alt = altText || '';
    }

    function renderViewerAndInfo() {
      const product = getCurrentProduct();

      if (!product) {
        setViewerImage(placeholderImage || '', 'Unavailable product');
        if (viewerLink) {
          viewerLink.href = '#';
          viewerLink.setAttribute('aria-disabled', 'true');
        }
        titleEl.textContent = '';
        priceEl.innerHTML = '';
        sizesWrap.innerHTML = '';
        selectedColorEl.textContent = '';
        emptyEl.hidden = false;
        s.selectedVariantId = null;
        return;
      }

      const variant = resolveSelectedVariant(product);
      const image = getVariantPreviewImage(product, s.selectedColorLabel, s.selectedSize) || placeholderImage || '';

      emptyEl.hidden = true;
      setViewerImage(image, product.title);

      if (viewerLink) {
        viewerLink.href = product.url || '#';
        viewerLink.removeAttribute('aria-disabled');
      }

      titleEl.textContent = product.title;
      priceEl.innerHTML = renderPrice(variant);
      selectedColorEl.textContent = s.selectedColorLabel || '';

      const sizeVariants = getSizeVariants(product);
      sizesWrap.innerHTML = '';

      if (!sizeVariants.length) {
        return;
      }

      sizeVariants.forEach((sizeVariant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ac-size-btn' + (normalize(sizeVariant.size) === normalize(s.selectedSize) ? ' is-active' : '');
        btn.textContent = sizeVariant.size;

        btn.addEventListener('click', () => {
          s.selectedSize = sizeVariant.size;
          resolveSelectedVariant(product);
          renderViewerAndInfo();
        });

        sizesWrap.appendChild(btn);
      });
    }

    function renderAll() {
      renderSwatches();
      renderProducts();

      const product = getCurrentProduct();
      if (product) {
        resolveSelectedVariant(product);
      }

      renderViewerAndInfo();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => moveProduct(-1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => moveProduct(1));
    }

    let touchStartX = 0;
    let touchStartY = 0;

    if (viewerLink) {
      viewerLink.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        },
        { passive: true }
      );

      viewerLink.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          const dx = touch.clientX - touchStartX;
          const dy = touch.clientY - touchStartY;

          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            suppressViewerClickUntil = Date.now() + 500;
            moveProduct(dx < 0 ? 1 : -1);
          }
        },
        { passive: true }
      );

      viewerLink.addEventListener('click', (event) => {
        if (Date.now() < suppressViewerClickUntil) {
          event.preventDefault();
          return;
        }

        if (viewerLink.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
        }
      });
    }

    const infoBlock = panel.querySelector('[data-ac-info]');
    const viewer = panel.querySelector('[data-ac-viewer]');

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    let infoToggleBtn = null;

    function setupMobileInfo() {
      if (!infoBlock || !viewer) return;

      if (!isMobile()) {
        infoBlock.classList.remove('is-open');
        if (infoToggleBtn) {
          infoToggleBtn.remove();
          infoToggleBtn = null;
        }
        return;
      }

      if (infoToggleBtn) return;

      infoToggleBtn = document.createElement('button');
      infoToggleBtn.type = 'button';
      infoToggleBtn.className = 'ac-info-toggle';
      infoToggleBtn.textContent = 'Info';

      infoToggleBtn.addEventListener('click', () => {
        const isOpen = infoBlock.classList.toggle('is-open');
        infoToggleBtn.textContent = isOpen ? 'Close' : 'Info';
      });

      viewer.appendChild(infoToggleBtn);
    }

    setupMobileInfo();

    window.addEventListener('resize', setupMobileInfo);

    renderAll();
  }

  function initBuyButton() {
    const buyButton = document.querySelector('[data-ac-buy]');
    if (!buyButton) return;

    buyButton.addEventListener('click', async () => {
      const topState = state.top;
      const shortsState = state.shorts;

      const items = [];

      if (topState && topState.selectedVariantId) {
        items.push({ id: Number(topState.selectedVariantId), quantity: 1 });
      }

      if (shortsState && shortsState.selectedVariantId) {
        items.push({ id: Number(shortsState.selectedVariantId), quantity: 1 });
      }

      if (!items.length) {
        alert('Please select at least one item.');
        return;
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      buyButton.disabled = true;

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        alert('Could not add items to cart.');
      } finally {
        buyButton.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ac-panel]').forEach(initPanel);
    initBuyButton();
  });
})();